const emailjsConfig = {
  SERVICE_ID: 'service_p7y28s7',
  TEMPLATE_ID: 'template_2sgfeve',
  PUBLIC_KEY: 'ERBIvxDNMBkpEELRc',
};

export default emailjsConfig;
